import { Sport, SportOrShared } from '#src/__generated__/globalTypes.ts';
import type { unitMapping } from '#src/lib/style.ts';

import { Ball } from './Ball.tsx';
import { MLBBall } from './MLBBall.tsx';
import { NBABall } from './NBABall.tsx';

const iconPerSport = {
  [Sport.FOOTBALL]: Ball,
  [Sport.NBA]: NBABall,
  [Sport.BASEBALL]: MLBBall,
};

type Props = {
  sport: Sport | SportOrShared;
  className?: string;
  size?: keyof typeof unitMapping;
};

export const SportBall = ({ sport, className, size = 2 }: Props) => {
  const Icon = sport === SportOrShared.GLOBAL ? null : iconPerSport[sport];
  if (!Icon) {
    return null;
  }
  return <Icon size={size} className={className} />;
};
